import styled, { css } from 'styled-components';

import { rem } from 'approot/shared/style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { spacing12 } from 'approot/shared/styles/spacing.style';
import { richtextCommonCss } from 'approot/shared/richtext/richtext.style';
import { INFO_BOX_COLOURS } from './info-box.constants';
import { InquisitiveContentFlexAlignment } from 'global/graphql/scalars.type';
import { FLEX_ALIGN_START } from 'global/constants';

const baseInfoBox = css<InfoBoxBoxProps>`
  background-color: ${({ $colour }) =>
    INFO_BOX_COLOURS.find(c => c.base === $colour)?.colour2};
  border-radius: ${rem(borderRadius8)};
  max-width: ${({ $width }) => $width || 100}%;
  width: 100%;
`;

export const lightInfoBox = css<InfoBoxBoxProps>`
  ${baseInfoBox}
  background-color: ${({ $colour }) =>
    INFO_BOX_COLOURS.find(c => c.base === $colour)?.colour1};
`;

export type InfoBoxBoxProps = {
  $colour: string;
  $isZoomed?: boolean;
  $width?: number | null;
};
export const InfoBox = styled.div<InfoBoxBoxProps>`
  ${baseInfoBox}

  .ProseMirror {
    background-color: transparent;
    padding: ${rem(spacing12)};
  }
`;

export const InfoBoxView = styled.div<InfoBoxBoxProps>`
  ${baseInfoBox}
  ${richtextCommonCss}
  padding: ${rem(spacing12)};
`;

type InfoBoxContainerProps = {
  $textAlignment: InquisitiveContentFlexAlignment | undefined | null;
};
export const InfoBoxContainer = styled.div<InfoBoxContainerProps>`
  display: flex;
  justify-content: ${({ $textAlignment = FLEX_ALIGN_START }) => $textAlignment};
  width: 100%;
`;
